<i
    class="pseudo--border-off bi d-print-none"
    [attr.aria-disabled]="interactive() && disabled() ? true : null"
    [attr.aria-hidden]="decorative() ? true : null"
    [attr.aria-controls]="ariaControls() || null"
    [attr.aria-expanded]="ariaExpanded() ?? null"
    [attr.aria-label]="accessibleName()"
    [attr.role]="interactive() ? 'button' : null"
    [attr.tabindex]="interactive() && !disabled() ? 0 : null"
    [ngClass]="[iconClass(), 'bi-' + type(), pseudo() ? 'pseudo pseudo--' + pseudo() : '']"
    [style.font-size.rem]="fontSize()"
    [attr.title]="titleTextMutate()"
    [class.pseudo--disabled]="disabled()"
    (click)="onClick()"
    (keydown.enter)="onKeyActivate($event)"
    (keydown.space)="onKeyActivate($event)">
</i>
